export default {
  setActiveItem(state, item) {
    state.activeItem = item;
  },

  stop(state) {
    state.isRunning = false;
  },

  start(state) {
    state.isRunning = true;
  },

  setContinueToNextState(state, value) {
    state.continueToNextState = value;
  },
};
